import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MassEditRoutingModule } from './mass-edit-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SharedComponentModule } from 'src/app/modules/shared/shared.module';
import { PrimngDesignModule } from 'src/app/modules/primng-design/primng-design.module';
import { ReportsSharedModule } from 'src/app/reports/reports-shared.module';
import { MassEditComponent } from './mass-edit.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddEditMassComponent } from './add-edit-mass/add-edit-mass.component';
import { ManuallySettingComponent } from './add-edit-mass/manually-setting/manually-setting.component';
// import { TreeSelectModule } from 'primeng/treeselect';

@NgModule({
    declarations: [
        MassEditComponent,
        AddEditMassComponent,
        ManuallySettingComponent
    ],
    imports: [
        CommonModule,
        MassEditRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ContextMenuModule,
        SharedComponentModule,
        PrimngDesignModule,
        ReportsSharedModule,
        // TreeSelectModule
    ],
    providers: [
        ConfirmationService,
        MessageService
    ],
    exports: [
        ManuallySettingComponent
    ]
})
export class MassEditModule { }
